/* eslint-disable */
import { mapState, mapGetters } from 'vuex';
import { RecaptchaSettingsCacheMixin } from './RecaptchaSettingsCacheMixin'
import { SelectedSiteIdMixin } from './SelectedSiteIdMixin'
import { CompleteStatusEmitterMixin } from '@/mixins/Booking/CompleteStatusEmitterMixin'
import { TurnstileExecuteMixin } from './TurnstileExecuteMixin'

export const BookingAddMixin = {
    mixins: [SelectedSiteIdMixin, RecaptchaSettingsCacheMixin, CompleteStatusEmitterMixin, TurnstileExecuteMixin],
    data() {
        return {
            error: '',
            termsAccepted: false,
            termsMessage: '',
            addedBooking: '',
            displayRecaptcha: false
        }
    },
    computed: {
        ...mapGetters('BookingUpload', [
            'bookingUploadModel',
        ]),
        ...mapState('TimeZone', [
            'selectedTimeZoneId'
        ]),
        ...mapState('Booking', [
            'addingBooking'
        ]),
        ...mapState('ApplicationEvents', [
            'bookAppointmentEvent',
            'bookingAddedEvent'
        ]),
        loading() {
            return !!this.addingBooking || !!this.fetchingRecaptchaSettings || !!this.pendingRecaptcha;
        },
        participants() {
            console.log('!!!OVERRIDE COMPUTED --- participants!!!')
        },
        bookingAddModel() {
            console.log('!!!OVERRIDE COMPUTED --- bookingAddModel!!!')
        },
        recaptchaValid() {
            return !this.recaptchaEnabled || !!this.bookingAddModel.recaptcha;
        },
        bookingAddModel() {
            return Object.assign({}, this.bookingUploadModel, {
                participants: this.participants,
                timeZoneId: this.selectedTimeZoneId,
                recaptcha: this.recaptcha
            });
        },
        bookingAddModelValid() {
            const self = this;
            const model = self.bookingAddModel;
            return self.recaptchaValid
                && !!model.firstName
                && !!model.lastName
                && !!model.email
                && !!model.startUtc
                && !!model.duration
                && !!model.timeZoneId
                && model.participants.length > 0
        },
        bookingCompleted() {
            return !!this.addedBooking ? this.addedBooking.id : '';
        },
        status() {
            return {
                error: this.error,
                completed: this.bookingCompleted,
                loading: this.loading
            }
        },
        canAddBooking() {
            return !this.bookingCompleted;
        },
        addedBookingStatus() {
            return !!this.addedBooking && this.addedBooking.status ?  this.addedBooking.status : null; 
        },
        unknownStatus(){
            return !!this.addedBookingStatus && this.addedBookingStatus.id === 0 ? true : false;
        }
    },
    watch: {
        termsAccepted(value) {
            this.validateTerms();
            if(!!value && !this.displayRecaptcha && !this.bookingCompleted) {
                this.displayRecaptcha = true;
            }
        },
        bookingAddedEvent(booking) {
            this.addedBooking = booking;
            this.displayRecaptcha = false;
            this.stopPending();
        },
        bookAppointmentEvent() {
            this.onValidatedChanged();
        }
    },
    methods: {
        tryAddBooking() {
            console.log('!!!OVERRIDE COMPUTED --- tryAddBooking!!!')
        },
        refreshRecaptchaSettings() {
            //do nothing
        },
        onValidatedChanged() {
            const self = this;
            self.validateTerms();
            if (!self.canAddBooking || !!self.termsMessage) {
                return;
            }
            if(!!self.unknownStatus || !!self.pendingRecaptcha || !!self.addingBooking) {
                return;
            }
            if(!self.recaptchaValid) {
                self.requestRecaptcha(self.onValidatedChanged);
                return;
            }
            self.tryAddBooking();
        },
        validateTerms() {
            this.termsMessage = (!!this.termsAccepted || !!this.bookingCompleted) ? '' : 'Please agree to the Terms and Conditions.';
        },
        displayTerms() {
            this.$emit('displayTerms')
        }
    }
}
